import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, BasicInput } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function InsuranceManagementEditTemplate({ insuranceManagementEditViewStore }) {
    const {
        contentLoading,
        form,
        pricingGroupStore,
        isSyncing,
        syncNikoPriceGroups,
        placeOfServiceStore
    } = insuranceManagementEditViewStore;

    return (
        <ApplicationEditLayout store={insuranceManagementEditViewStore}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-8 col-lrg-7">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('abbreviatedName')} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('description')} />
                                </div>
                                <div className="form__group col col-med-6">
                                    <div className="form__group__label">
                                    {<React.Fragment>Pricing Group<span className="validation__mark">*</span></React.Fragment>}
                                        <i title='Sync Pricing Groups' className={`u-icon u-icon--sml u-icon--synchronize--${isSyncing ? "grey" : "primary"} u-mar--left--tny`} onClick={ isSyncing ? () => {} : () => syncNikoPriceGroups()}></i>
                                    </div>
                                    <BaasicFieldDropdown allowEmpty={false} field={form.$('pricingGroupId')} store={pricingGroupStore} labelDisplayed={false}/>
                                </div>
                                <div className="form__group col col-med-6">
                                    <BaasicFieldDropdown field={form.$('placeOfServiceId')} store={placeOfServiceStore}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

InsuranceManagementEditTemplate.propTypes = {
    insuranceManagementEditViewStore: PropTypes.object
};

export default defaultTemplate(InsuranceManagementEditTemplate);
